/**
 * @generated SignedSource<<1a3090379ebd8f7b403e519d9688760b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type PostList_post$data = {
  readonly slug: string
  readonly h1: string
  readonly ' $fragmentType': 'PostList_post'
}
export type PostList_post$key = {
  readonly ' $data'?: PostList_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'PostList_post'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'PostList_post',
  selections: [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'slug',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'h1',
      storageKey: null
    }
  ],
  type: 'Post',
  abstractKey: null
}

;(node as any).hash = '13eca1494dd196da7b2ab67e0f2884b9'

export default node
